import BaseService from './BaseService';

export default class SearchService extends BaseService {
  static endpoint = '/search/movie';
}
